import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "..";
import { State } from "../state";

/**
 * Steuert den Menu-Drawer.
 * Dieser wird nur onMobile angezeigt.
 */
export const drawerSlice = createSlice({
    name: "drawer",
    initialState: {
        isOpen: false,
    } as State.Drawer,
    reducers: {
        /**
         * Öffnet oder schließt den Menu-Drawer.
         */
        setIsDrawerOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setIsDrawerOpen } = drawerSlice.actions;

export const useDrawerSlice = () => useSelector((state: RootState) => state.drawer);

export default drawerSlice.reducer;
